import * as React from 'react';

import parseISO from 'date-fns/parseISO';

import { Redirect } from 'react-router-dom';
import { FullMatchFragment } from '../../generated/graphql';
import { useTitle } from '../../useTitle';
import { MatchPendingText } from '../Match/MatchPendingText';

import { ButtonLink } from '../../components/Button';
import { paths } from '../../paths';
import { isNil } from '../../utils/isNil';
import { VoteWizard } from './VoteWizard';

export interface Props {
  match: FullMatchFragment;
  voteTypeId: string;
}

export const CreateVote = ({ match, voteTypeId }: Props) => {
  useTitle(`Vote | Match vs ${match.opponent}`);
  if (match.votingStatus === 'CLOSED') {
    return (
      <div className="space-y-4">
        <p>Voting for this match is now closed</p>
        <ButtonLink to={paths.match.votes.read(match.id)}>
          Read votes
        </ButtonLink>
      </div>
    );
  }

  if (match.votingStatus === 'PENDING') {
    return <MatchPendingText playedAt={parseISO(match.playedAt)} />;
  }
  const voteType = match.team.voteTypes.find(({ id }) => id === voteTypeId);

  if (isNil(voteType)) {
    return <Redirect to={paths.match.votes.vote(match.id)} />;
  }

  return <VoteWizard match={match} voteType={voteType} />;
};
